import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  CardMedia,
  Avatar,
} from "@material-ui/core";
import NavBar from "../component/NavBar";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import HttpClient from "../api/HttpClient";
import { useLoading } from "../constant/LoadingContext";
import { SnackbarContext } from "../constant/SnackbarProvider";

const LinkingPage = () => {
  const classes = useStyles();
  const location = useLocation();
  const Snackbar = useContext(SnackbarContext);
  const [linkValue, setLinkValue] = useState(null);
  const { setLoading } = useLoading();
  const _brand = location?.state?.brand;

  const _pm = require("../icons/perfectMedical.png");
  const _goku = require("../icons/goku.png");

  useEffect(() => {
    setLoading(true);

    HttpClient().FetchExternalLink(
      { brand: _brand },
      (data) => {
        setLinkValue(data);
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        Snackbar.open({
          alertProps: { severity: "error" },
          message: error,
        });
        setLoading(false);
      }
    );
  }, []);

  const handleCopyLink = async () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator?.clipboard?.writeText(linkValue.link);

        alert("Link copied to clipboard!");
      } catch (err) {
        alert("Failed to copy link: " + err);
      }
    } else {
      // Fallback for browsers that do not support the Clipboard API
      const textArea = document.createElement("textarea");
      textArea.value = linkValue.link;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        alert("Link copied to clipboard!");
      } catch (err) {
        alert("Failed to copy link: " + err);
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <>
      <Container className={classes.container}>
        <NavBar isBack={true} />
        <div style={{ backgroundColor: "#F0EFF6", minHeight: "90%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "90vh",
            }}
          >
            <Paper
              style={{
                display: "flex",
                flexDirection: "column",
                width: "50%",
                height: "80%",
                padding: "2rem",
                borderRadius: "2rem",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  paddingTop: "5rem",
                  alignItems: "center",
                  paddingBottom: "4rem",
                }}
              >
                <Avatar alt="" src={_brand === "PM" ? _pm : _goku} />
                <Typography
                  variant="h5"
                  className={classes.title}
                  style={{ paddingLeft: "1rem" }}
                >
                  {`PERFECT ${
                    _brand === "PM" ? "MEDICAL" : "GOKU"
                  } 個人資料表格連結`}
                </Typography>
              </div>
              <Typography
                variant="h5"
                className={classes.title}
                style={{
                  width: "50%",
                  fontSize: "0.8rem",
                  wordBreak: "break-word", // 确保长单词换行
                  whiteSpace: "normal", // 允许文本换行
                  overflowWrap: "break-word", // 确保长单词换行
                  textDecoration: "underline",
                  paddingBottom: "2rem",
                }}
              >
                {linkValue?.link}
              </Typography>
              <Button
                variant="contained"
                color={"primary"}
                onClick={handleCopyLink}
                className={classes.button}
                startIcon={
                  <CardMedia
                    component="img"
                    image={require("../icons/linker.png")}
                    alt=""
                    className={classes.media}
                  />
                }
              >
                複製連結
              </Button>
              <Typography
                variant="h5"
                className={classes.title}
                style={{ paddingTop: "5rem" }}
              >
                {`連結到期時間 : ${moment(linkValue?.expiryDate).format(
                  "YYYY-MM-DD HH:mm:ss"
                )}`}
              </Typography>
            </Paper>
          </div>
        </div>
      </Container>
    </>
  );
};

export default LinkingPage;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
  },
  title: { color: "#454C96", fontWeight: 500 },
  container: {
    // display: "flex",
    height: "100vh",
    borderRadius: "10rem",
  },

  input: {
    margin: theme.spacing(1, 0),
  },
  button: {
    margin: theme.spacing(1, 0),
    width: "50%",
  },
  media: {
    width: "20px",
    height: "20px",
    margin: "5px",
    objectFit: "contain",
  },
}));
